import { Currency, FinancialServiceProviderAdapters } from '@seapoint/server/enums';

const VOP_REQUIRED_CURRENCIES = [Currency.EUR];
const VOP_REQUIRED_FSP_ADAPTERS = [FinancialServiceProviderAdapters.MODULR, FinancialServiceProviderAdapters.YAPILY];

type IsVopCheckRequiredArgs = {
  currency: Currency;
  fspAdapter: FinancialServiceProviderAdapters;
};

export const isVopCheckRequired = ({ currency, fspAdapter }: IsVopCheckRequiredArgs) => {
  return VOP_REQUIRED_CURRENCIES.includes(currency) && VOP_REQUIRED_FSP_ADAPTERS.includes(fspAdapter);
};
